import React, { useContext, useMemo, useState } from 'react';
import 'chart.js/auto';
import { Spin } from 'antd';
import { DefaultOptionType } from 'antd/es/select';
import StatisticsFilter, { Filter } from '../../statistics/StatisticsFilter';
import "./StatisticsView.scss";
import { ConfigContext } from '../../../contexts/ConfigContext';
import { useStatisticsServiceGetStatistics360Spin, useStatisticsServiceGetStatistics360SpinKey, useStatisticsServiceGetStatisticsAsset, useStatisticsServiceGetStatisticsAssetKey, useStatisticsServiceGetStatisticsCutout, useStatisticsServiceGetStatisticsCutoutKey, useStatisticsServiceGetStatisticsDamupload, useStatisticsServiceGetStatisticsDamuploadKey, useStatisticsServiceGetStatisticsInsitu, useStatisticsServiceGetStatisticsInsituKey, useStatisticsServiceGetStatisticsProject, useStatisticsServiceGetStatisticsProjectKey, useStatisticsServiceGetStatisticsScene, useStatisticsServiceGetStatisticsSceneKey, useStatisticsServiceGetStatisticsStyling, useStatisticsServiceGetStatisticsStylingKey, useStatisticsServiceGetStatisticsUsage, useStatisticsServiceGetStatisticsUsageKey, useStatisticsServiceGetStatisticsVideo, useStatisticsServiceGetStatisticsVideoKey } from '../../../openapi/queries';
import dayjs from 'dayjs';
import StatisticsUsage from './StatisticsUsage';
import ToggleButton from '../../layout/elements/ToggleButton';
import { ChartDTO } from '../../../openapi/requests';
import StatisticsChart from './StatisticsChart';

const StatisticsView: React.FC = () => {

    const { currentClient, odataFilters } = useContext(ConfigContext)

    const [filters, setFilters] = useState<Filter[]>([]);
    const [DAMfilters, setDAMFilters] = useState<Filter[]>([]);
    const [displayData, setDisplayData] = useState<string[]>(['current'])

    const [displayMode, setDisplayMode] = useState<string>("");

    const mappedFilters = useMemo(() => {

        let dateValues = filters.find(x => x.property === "date");
        let startDate = dayjs('2023-11-01')
        let endDate = dayjs().endOf("week");

        if (dateValues && dateValues.values.length > 0) {
            startDate = dayjs(dateValues.values[0]);

            if (dateValues.values.length > 1)
                endDate = dayjs(dateValues.values[1]);
        }

        let userValue = filters.find(x => x.property === "user");
        let userId = null;
        if (userValue) {
            userId = userValue.values[0].value;
        }

        let intervalValue = filters.find(x => x.property === "interval");
        let interval = "month";
        if (intervalValue) {
            interval = intervalValue.values[0].value;
        }

        let renderTypeValue = filters.find(x => x.property === "rendertype");
        let renderType = "final";
        if (renderTypeValue) {
            renderType = renderTypeValue.values[0].value;
        }

        if (displayMode === "lastyear") {
            startDate = dayjs().set("month", 1).startOf("month");
            endDate = dayjs().add(1, "year").set("month", 0).endOf("month");
            interval = "month";
            userId = null;
        }

        return {
            startDate: startDate.format("YYYY-MM-DD"),
            endDate: endDate.format("YYYY-MM-DD"),
            dateInterval: interval,
            renderType: renderType,
            userId: userId,
            isEnabled: true,
            clientId: currentClient.id,
            displayMode: displayMode
        }

    }, [currentClient.id, displayMode, filters]);

    const mappedDAMFilters = useMemo(() => {

        let dateValues = DAMfilters.find(x => x.property === "date");
        let startDate = dayjs('2023-11-01')
        let endDate = dayjs().endOf("week");

        if (dateValues && dateValues.values.length > 0) {
            startDate = dayjs(dateValues.values[0]);

            if (dateValues.values.length > 1)
                endDate = dayjs(dateValues.values[1]);
        }

        let intervalValue = DAMfilters.find(x => x.property === "interval");
        let interval = "month";
        if (intervalValue) {
            interval = intervalValue.values[0].value;
        }

        let userValue = filters.find(x => x.property === "user");
        let userId = null;
        if (userValue) {
            userId = userValue.values[0].value;
        }

        let templateTypeValue = DAMfilters.find(x => x.property === "templateType");
        let templateType = "";
        if (templateTypeValue) {
            templateType = templateTypeValue.values[0].value;
        }

        if (displayMode === "lastyear") {
            startDate = dayjs().set("month", 1).startOf("month");
            endDate = dayjs().add(1, "year").set("month", 0).endOf("month");
            interval = "month";
            userId = null;
        }

        return {
            startDate: startDate.format("YYYY-MM-DD"),
            endDate: endDate.format("YYYY-MM-DD"),
            dateInterval: interval,
            userId: userId,
            isEnabled: true,
            templateType: templateType,
            displayMode: displayMode
        }

    }, [DAMfilters, displayMode, filters])

    //  const { data: statistics, isFetched: statisticsFetched } = useStatisticsServiceGetStatistics({ ...mappedFilters }, [useStatisticsServiceGetStatisticsKey, mappedFilters], { refetchOnWindowFocus: false });
    const { data: insituData, isFetched: insituStatisticsFetched } = useStatisticsServiceGetStatisticsInsitu({ ...mappedFilters }, [useStatisticsServiceGetStatisticsInsituKey, mappedFilters], { refetchOnWindowFocus: false });
    const { data: cutoutData, isFetched: cutoutStatisticsFetched } = useStatisticsServiceGetStatisticsCutout({ ...mappedFilters }, [useStatisticsServiceGetStatisticsCutoutKey, mappedFilters], { refetchOnWindowFocus: false });
    const { data: spin360Data, isFetched: spin360StatisticsFetched } = useStatisticsServiceGetStatistics360Spin({ ...mappedFilters }, [useStatisticsServiceGetStatistics360SpinKey, mappedFilters], { refetchOnWindowFocus: false });
    const { data: videoData, isFetched: videoStatisticsFetched } = useStatisticsServiceGetStatisticsVideo({ ...mappedFilters }, [useStatisticsServiceGetStatisticsVideoKey, mappedFilters], { refetchOnWindowFocus: false });

    const { data: assetsData, isFetched: assetsStatisticsFetched } = useStatisticsServiceGetStatisticsAsset({ ...mappedFilters }, [useStatisticsServiceGetStatisticsAssetKey, mappedFilters], { refetchOnWindowFocus: false });
    const { data: scenesData, isFetched: scenesStatisticsFetched } = useStatisticsServiceGetStatisticsScene({ ...mappedFilters }, [useStatisticsServiceGetStatisticsSceneKey, mappedFilters], { refetchOnWindowFocus: false });
    const { data: stylingData, isFetched: stylingStatisticsFetched } = useStatisticsServiceGetStatisticsStyling({ ...mappedFilters }, [useStatisticsServiceGetStatisticsStylingKey, mappedFilters], { refetchOnWindowFocus: false });

    const { data: projectsData, isFetched: projectsStatisticsFetched } = useStatisticsServiceGetStatisticsProject({ ...mappedFilters }, [useStatisticsServiceGetStatisticsProjectKey, mappedFilters], { refetchOnWindowFocus: false });
    const { data: DAMuploadsData, isFetched: DAMuploadsStatisticsFetched } = useStatisticsServiceGetStatisticsDamupload({ ...mappedDAMFilters }, [useStatisticsServiceGetStatisticsDamuploadKey, mappedDAMFilters], { refetchOnWindowFocus: false });


    const { data: usage, isFetched: usageFetched } = useStatisticsServiceGetStatisticsUsage({ ...mappedFilters }, [useStatisticsServiceGetStatisticsUsageKey, currentClient], { refetchOnWindowFocus: false });

    const dateIntervalOptions: DefaultOptionType[] = [
        { label: "Week", value: "week" },
        { label: "Month", value: "month" },
        { label: "Quarter", value: "quarter" },
        { label: "Year", value: "year" }
    ];

    const renderTypeOptions = [
        { label: "Preview", value: "preview" },
        { label: "Final", value: "final" },
    ]

    const templateTypeOptions = [
        { label: "In-situ", value: "insitu" },
        { label: "Cutout", value: "cutout" },
        { label: "360 Spin", value: "spin360" },
        { label: "Video", value: "video" }
    ];

    type StatisticsFilterProperties = {
        defaultValue?: string,
        clearable?: boolean;
        name: string,
        property: string,
        type: string,
        items: any;
    }

    let properties = Array<StatisticsFilterProperties>()
    let DAMproperties = Array<StatisticsFilterProperties>()

    properties = [
        { name: 'Date', property: 'date', type: 'daterange', items: [] },
        { name: 'Interval', property: 'interval', type: 'select', items: dateIntervalOptions, defaultValue: "month" },
        { name: 'Render Type', property: 'rendertype', type: 'select', items: renderTypeOptions },
    ];

    DAMproperties = [
        { name: 'Type', property: 'templateType', type: 'select', items: templateTypeOptions, clearable: true },
    ];

    const onChange = (filters: Filter[]) => {
        var updatedFilters = filters.filter(x => x.values.length > 0);
        setFilters([...updatedFilters]);
    }

    const onChangeDAM = (filters: Filter[]) => {
        var updatedFilters = filters.filter(x => x.values.length > 0);
        setDAMFilters([...updatedFilters]);
    }

    const onShowLastYear = (toggled: boolean) => {

        let displayData = ["current"];
        let displayMode = ""
        if (toggled) {
            displayData.push("lastyear");
            displayMode = "lastyear";
        }
        setDisplayData(displayData)
        setDisplayMode(displayMode);

    }

    return (
        <div className='admin-statistics-page-view'>

            <Spin spinning={!usageFetched}>
                {usageFetched ? <StatisticsUsage items={usage} /> : null}
            </Spin>

            <div className='admin-statistics-filters-wrapper'>
                <StatisticsFilter isOpen={true} filters={filters} onChange={onChange} properties={properties} disabled={displayMode.length > 0} />
                <ToggleButton className='has-icon button secondary' onToggle={onShowLastYear}>Compare Last/Current Fiscal Year</ToggleButton>
            </div>

            <div className='statistics-page-charts'>

                <div className='statistics-page-charts-body'>
                    <h1>Assets Generated</h1>
                    <AdminStatisticsChartWrapper data={insituData} fetched={insituStatisticsFetched} displayData={displayData} />
                    <AdminStatisticsChartWrapper data={cutoutData} fetched={cutoutStatisticsFetched} displayData={displayData} />
                    <AdminStatisticsChartWrapper data={spin360Data} fetched={spin360StatisticsFetched} displayData={displayData} />
                    <AdminStatisticsChartWrapper data={videoData} fetched={videoStatisticsFetched} displayData={displayData} />
                </div>

                <div className='statistics-page-charts-body'>
                    <h1>Assets Implemented</h1>
                    <AdminStatisticsChartWrapper data={assetsData} fetched={assetsStatisticsFetched} displayData={displayData} />
                    <AdminStatisticsChartWrapper data={scenesData} fetched={scenesStatisticsFetched} displayData={displayData} />
                    <AdminStatisticsChartWrapper data={stylingData} fetched={stylingStatisticsFetched} displayData={displayData} />
                </div>

                <div className='statistics-page-charts-body'>
                    <h1>DAM Uploads</h1>
                    <StatisticsFilter isOpen={true} filters={DAMfilters} onChange={onChangeDAM} properties={DAMproperties} />
                    <AdminStatisticsChartWrapper data={DAMuploadsData} fetched={DAMuploadsStatisticsFetched} displayData={displayData} />
                </div>

                <div className='statistics-page-charts-body'>
                    <h1>Projects Created</h1>
                    <AdminStatisticsChartWrapper data={projectsData} fetched={projectsStatisticsFetched} displayData={displayData} />
                </div>

            </div>

            {/* <Spin spinning={!statisticsFetched}>
                {statisticsFetched ? <div className='admin-statistics-page-charts'>

                    <div className='admin-statistics-page-charts-body'>
                        <h1>Assets Generated</h1>
                        {(statistics?.value ?? []).filter(x => ['In-situ', 'Cut-out', '360° Spin', 'Video'].includes(x.name)).map(chart => (
                            <div className="admin-statistics-page-chart" key={chart.id}>
                                <div className='admin-statistics-page-chart-body'>
                                    {chart.data.map(chartData => (
                                        <div className="admin-statistics-chart-wrapper" key={chart.id + "_" + chartData.name}>
                                            <h2>{chartData.name}</h2>
                                            <StatisticsChart labels={chart.labels} chartData={chartData} color="#adadad" displayData={displayData} />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className='admin-statistics-page-charts-body'>
                        <h1>Assets Implemented</h1>
                        {(statistics?.value ?? []).filter(x => ['Scenes', 'Assets', 'Styling'].includes(x.name)).map(chart => (
                            <div className="admin-statistics-page-chart" key={chart.id}>
                                <div className='admin-statistics-page-chart-body'>
                                    {chart.data.map(chartData => (
                                        <div className="admin-statistics-chart-wrapper" key={chart.id + "_" + chartData.name}>
                                            <h2>{chartData.name}</h2>
                                            <StatisticsChart labels={chart.labels} chartData={chartData} color="#adadad" displayData={displayData} />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className='admin-statistics-page-charts-body'>
                        <h1>DAM Uploads</h1>
                        {(statistics?.value ?? []).filter(x => ['DAMUploads'].includes(x.name)).map(chart => (
                            <div className="admin-statistics-page-chart" key={chart.id}>
                                <div className='admin-statistics-page-chart-body'>
                                    {chart.data.map(chartData => (
                                        <div className="admin-statistics-chart-wrapper" key={chart.id + "_" + chartData.name}>
                                            <h2>{chartData.name}</h2>
                                            <StatisticsChart labels={chart.labels} chartData={chartData} color="#adadad" displayData={displayData} />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className='admin-statistics-page-charts-body'>
                        <h1>Projects</h1>
                        {(statistics?.value ?? []).filter(x => ['Projects'].includes(x.name)).map(chart => (
                            <div className="admin-statistics-page-chart" key={chart.id}>
                                <div className='admin-statistics-page-chart-body'>
                                    {chart.data.map(chartData => (
                                        <div className="admin-statistics-chart-wrapper" key={chart.id + "_" + chartData.name}>
                                            <h2>{chartData.name}</h2>
                                            <StatisticsChart labels={chart.labels} chartData={chartData} color="#adadad" displayData={displayData} />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                    : null}
            </Spin> */}
        </div>
    )
}

const AdminStatisticsChartWrapper: React.FC<{ data: ChartDTO, fetched: boolean, displayData?: string[] }> = ({ data, fetched, displayData }) => {

    return (
        <div className="statistics-page-chart">
            {!fetched ? <div className="statistics-loader"><Spin spinning={!fetched} /></div> : null}
            <div className='statistics-page-chart-body'>
                {data && data.data.map(chartData => (
                    <div className="statistics-chart-wrapper" key={data.id + "_" + chartData.name}>
                        <h2>{chartData.name}</h2>
                        <StatisticsChart labels={data.labels} chartData={chartData} color="#adadad" displayData={displayData ?? []} />
                    </div>
                ))}
            </div>
        </div>
    )

}

export default StatisticsView;